// Example: src/services/api.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_PULSE_API_BASE_URL || 'http://localhost:8080';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log(`-------------- using API from url: ${apiClient.defaults.baseURL}\n`);

// Add interceptors for auth tokens etc. if needed

export default apiClient;
